import React, { Component } from 'react'
import { Layout, Menu, Icon } from 'antd'
import Permissions from '../models/Permissions'
import AuthModel from '../models/AuthModel'
import '../assets/App.css'
import apaLogo from '../assets/images/apalogo_light_49x46_black.png'

const { Header, Content, Footer } = Layout
const SubMenu = Menu.SubMenu
const handleClick = (props, e) => {
    props.history.push(e.key)
}

class Public extends Component {

    render() {
        return (
            <Layout>
                <Header style={{ position: 'fixed', width: '100%' }}>
                    <div className="logo" />
                    <Menu onClick={(e) => handleClick(this.props, e)}
                        selectedKeys={[this.props.location.pathname]}
                        mode="horizontal"
                        theme="dark"
                      >
                        <Menu.Item key="/">
                          <img src={apaLogo} alt="APA Ambiente" title="APA Ambiente" />
                        </Menu.Item>
                        <Menu.Item key="/inicio">
                          <Icon type="home" />Inicio
                        </Menu.Item>
                        <Menu.Item key="/preform">
                          <Icon type="notification" /><span className="hide-small">Reportar</span>
                        </Menu.Item>
                        <Menu.Item key="/search">
                          <Icon type="search" /><span className="hide-small">Pesquisar</span>
                        </Menu.Item>

                        {AuthModel.isAuthenticated() ? (
                            <Menu.Item key="/docs">
                            <Icon type="file" /><span className="hide-small">Documentos</span>
                            </Menu.Item>
                        ) : null }

                        {AuthModel.isAuthenticated() ? (
                            <SubMenu title={<span><Icon type="user" /><span className="hide-small">{this.props.username}</span></span>}>
                                <Menu.Item key="/settings">
                                  <Icon type="setting" />Definições
                                </Menu.Item>
                                { !Permissions.isDenied("admin", 'home') ? (
                                    <Menu.Item key="/admin">
                                      <Icon type="usergroup-add" />Administração
                                    </Menu.Item>
                                ) : '' }
                                <Menu.Item key="/logout">
                                  <Icon type="lock" />Sair
                                </Menu.Item>
                            </SubMenu>
                        ) : (
                            <Menu.Item key="/login">
                              <Icon type="unlock" />Entrar
                            </Menu.Item>
                        )}

                    </Menu>

                </Header>
                <Content style={{ padding: '0 24px', marginTop: 64 }}>
                    <div style={{ background: '#fff', minHeight: 438 }}>
                        {this.props.children}
                    </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    ©2017 Agência Portuguesa do Ambiente | Núcleo de Monitorização Costeira e Risco
                </Footer>
            </Layout>
        )
    }
}

export default Public;



// WEBPACK FOOTER //
// ./src/components/Public.js